module.exports = __webpack_public_path__ + "static/img/android_overlay.44947da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/android_overlay.svg
// module id = x7hp
// module chunks = 0